import { render, staticRenderFns } from "./ErrorReportsFrame.vue?vue&type=template&id=44d27f9a&"
import script from "./ErrorReportsFrame.vue?vue&type=script&lang=ts&"
export * from "./ErrorReportsFrame.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports